import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { TableWidget } from '../../../components/table-widget/TableWidget';
import './routerActivity.scss';
import axios from 'axios';
import { DnsActivityLayout } from '../../../components/dns-activity/DnsActivityLayout';
import { useTranslation } from 'react-i18next';

export interface LogsProps {
  summaryData: any;
  darkMode?: boolean;
}

export function RouterActivity({ summaryData, darkMode }: LogsProps) {
  const { t } = useTranslation();
  const { operatorId, cpeId } = useParams();

  const [checkboxSelected, setcheckboxSelected] = useState<string>('1d');
  const [startDateQuery, setStartDateQuery] = useState<string>('');
  const [endDateQuery, setEndDateQuery] = useState<string>('');
  const [formData, setFormData] = useState<any>({
    startDate: '',
    startTime: '',
    endDate: '',
    endTime: '',
  });
  const [isAllFilled, setIsAllFilled] = useState<boolean>(false);
  const [urlSearch, setUrlSearch] = useState<string>('');
  const [urlClicked, setUrlClicked] = useState<boolean>(false);
  const [reloadKey, setReloadKey] = useState<number>(0);
  const [hideSites, setHideSites] = useState<boolean>(false);
  const [dnsRequests, setDnsRequests] = useState([{ allUniqueUrlsVisited: 0 }, { allUniqueUrlsBlocked: 0 }]);

  useEffect(() => {
    fetchDnsRequests();
  }, [checkboxSelected]);

  useEffect(() => {
    const allFilled = Object.values(formData).every((input) => input !== '');
    setIsAllFilled(allFilled);
  }, [formData]);

  async function fetchDnsRequests() {
    const response = await axios.get(`/v2/op/dns-records/${operatorId}/dns-count/?l=${checkboxSelected}&cpeId=${cpeId}`);
    setDnsRequests(response.data.allDnsRequests);
  }

  const handleCheckboxChange = (value: string) => {
    if (checkboxSelected != value) {
      setHideSites(false);
    }
    setUrlClicked(false);
    setcheckboxSelected(value);
    setStartDateQuery('');
    setEndDateQuery('');
    setIsAllFilled(false);
    setReloadKey((prevKey) => prevKey + 1);
    setSelectedRange(value);
  };

  const clearFilter = () => {
    setFormData({
      startDate: '',
      startTime: '',
      endDate: '',
      endTime: '',
    });
  };

  const handleTimeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFormData((prevState: any) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleUrlRowClick = async (row: any) => {
    setUrlSearch(row.key.FQDN);
    setUrlClicked(false);
    setUrlClicked(true);
    setReloadKey((prevKey) => prevKey + 1);
  };

  const handleBackButton = () => {
    setUrlClicked(false);
    setUrlSearch('');
    setReloadKey((prevKey) => prevKey + 1);
  };

  const handleMarkerClick = (marker: any) => {
    setHideSites(marker);
  };
  const [selectedRange, setSelectedRange] = useState<string>('1d');

  return (
    <section id="router-dns-tab">
      <DnsActivityLayout
        darkMode={darkMode}
        selectedRange={selectedRange}
        onRangeChange={handleCheckboxChange}
        uniqueVisited={dnsRequests[0]?.allUniqueUrlsVisited}
        uniqueBlocked={dnsRequests[1]?.allUniqueUrlsBlocked}
        hideSites={hideSites}
        showBack={urlClicked}
        onBack={handleBackButton}
        blockedTable={
          <TableWidget
            hasSearch={true}
            url={`v2/op/dns-records/${operatorId}/list-records`}
            countPerPage={5}
            title={t('cpeTabs.activity.uniqueSitesBlocked')}
            searchPositionRight={true}
            hasCategoryFilter={true}
            cpeId={cpeId ? [Number(cpeId)] : []}
            deviceId={[]}
            startDate={startDateQuery}
            endDate={endDateQuery}
            isDns={true}
            needCategories={true}
            type={'BLOCKED'}
            urlSearch={urlClicked ? urlSearch : ''}
            key={`${urlSearch}-${checkboxSelected}-${cpeId}`}
            onRowSelect={handleUrlRowClick}
            selectedDate={checkboxSelected}
          />
        }
        activityTable={
          <TableWidget
            key={reloadKey}
            hasSearch={true}
            url={`v2/op/dns-records/${operatorId}/list-records`}
            countPerPage={11}
            title={t('cpeTabs.activity.dnsActivity')}
            searchPositionRight={true}
            selectedDate={checkboxSelected}
            startDate={startDateQuery}
            endDate={endDateQuery}
            isDns={true}
            type={urlClicked ? 'TIMESTAMP' : 'DNS'}
            cpeId={cpeId ? [Number(cpeId)] : []}
            deviceId={[]}
            hasCategoryFilter={true}
            needCategories={true}
            urlSearch={urlClicked ? urlSearch : ''}
            onRowSelect={handleUrlRowClick}
          />
        }
      />
    </section>
  );
}
